import holdVerifications from "./hold-verifications";

export default {
    holdVerifications,
};
